import { expandToBackendURL, nestContent } from '@plone/volto/helpers';

export const GET_UO_LIST = 'GET_UO_LIST';
export const GET_AVAILABLE_SLOTS = 'GET_AVAILABLE_SLOTS';
export const GET_PRENOTAZIONE = 'GET_PRENOTAZIONE';
export const GET_PRENOTAZIONI_LIST = 'GET_PRENOTAZIONI_LIST';
export const GET_BOOKING_SCHEMA = 'GET_BOOKING_SCHEMA';
export const ADD_BOOKING = 'ADD_BOOKING';
export const DELETE_BOOKING = 'DELETE_BOOKING';
export const RESET_DELETE = 'RESET_DELETE';
export const RESET_PRENOTAZIONE = 'RESET_PRENOTAZIONE';
export const GET_VOC_ORE = 'GET_VOC_ORE';
export const GET_VOC_BOOKING_TYPES = 'GET_VOC_BOOKING_TYPES';
export const MOVE_BOOKING = 'MOVE_BOOKING';
export const RESET_MOVE_BOOKING = 'RESET_MOVE_BOOKING';
export const ADD_VACATION = 'ADD_VACATION';
export const RESET_ADD_VACATION = 'RESET_ADD_VACATION';
export const BOOKING_REMINDER = 'BOOKING_REMINDER';
export const BOOKING_RESET_REMINDER = 'BOOKING_RESET_REMINDER';
export const UPDATE_BOOKING = 'UPDATE_BOOKING';
export const RESET_UPDATE_BOOKING = 'RESET_UPDATE_BOOKING';

/**
 * Get uo list
 * @function getUOList
 */
export function getUOList(service_uid = '', booking_type = '') {
  const listPath = `@bookable-uo-list?${new URLSearchParams({
    uid: service_uid || '',
    booking_type: booking_type || '',
  })}`;
  return {
    type: GET_UO_LIST,
    request: {
      op: 'get',
      path: listPath,
    },
  };
}

/**
 * Get available-slots
 * @function getAvailableSlots
 */
export function getAvailableSlots(
  folderPath,
  date = '',
  booking_type = '',
  firstAvailable = false,
) {
  let searchParams = {
    start: date || '',
    booking_type: booking_type || '',
  };
  if (firstAvailable) {
    searchParams.first_available = true;
  }
  const path = `${expandToBackendURL(
    folderPath,
  )}/@available-slots?${new URLSearchParams(searchParams)}`;

  return {
    type: GET_AVAILABLE_SLOTS,
    request: {
      op: 'get',
      path: path,
    },
  };
}

/**
 * Get prenotazione esistente
 * @function getPrenotazione
 */
export function getPrenotazione(bookingId) {
  const path = '@booking/' + bookingId;

  return {
    type: GET_PRENOTAZIONE,
    request: {
      op: 'get',
      path: path,
    },
  };
}

/**
 * Get lista prenotazioni
 * @function getPrenotazioniList
 */
export function getPrenotazioniList({
  folderPath,
  from = '',
  to = '',
  name = '',
  booking_type = '',
  gate = '',
  state = '',
  sort_on = 'Date',
  sort_order = 'ascending',
  fullObjects = false,
}) {
  const path = `${expandToBackendURL(
    folderPath,
  )}/@bookings?${new URLSearchParams({
    from: from,
    to: to,
    SearchableText: name ? `${name}*` : '',
    gate: gate,
    review_state: state,
    booking_type: booking_type,
    sort_on: sort_on,
    sort_order: sort_order,
    fullobjects: fullObjects ? 1 : 0,
  })}`;
  return {
    type: GET_PRENOTAZIONI_LIST,
    request: {
      op: 'get',
      path: path,
    },
  };
}

/**
 * Reset prenotazione state
 * @function resetPrenotazione
 */
export function resetPrenotazione() {
  return {
    type: RESET_PRENOTAZIONE,
  };
}

/**
 * Get prenotazione-schema
 * @function getBookingSchema
 */
export function getBookingSchema(folderPath, date) {
  const path = `${expandToBackendURL(
    folderPath,
  )}/@booking-schema?${new URLSearchParams({
    booking_date: date,
  })}`;
  return {
    type: GET_BOOKING_SCHEMA,
    request: {
      op: 'get',
      path: path,
    },
    date,
  };
}

/**
 * Post prenotazioni-add
 * @function addBooking
 * @path folderPath
 * @param {Date} booking_date
 * @param {String} booking_type
 * @param {Array} fields
 */

// TODO: propType
export function addBooking({
  folderPath,
  bookingDate,
  bookingType,
  fields,
  additional_fields,
  gate,
  duration,
  other_fields,
  force,
}) {
  const path = expandToBackendURL(folderPath) + '/@booking';

  return {
    type: ADD_BOOKING,
    request: {
      op: 'post',
      path: path,
      data: {
        booking_date: bookingDate,
        booking_type: bookingType,
        fields,
        additional_fields,
        duration,
        gate,
        other_fields,
        force,
      },
    },
  };
}

/**
 * DELETE booking
 * @function deleteBooking
 * @param {String} booking_id
 */

export function deleteBooking(bookingID) {
  const path = '@booking/' + bookingID;

  return {
    type: DELETE_BOOKING,
    request: {
      op: 'del',
      path: path,
    },
  };
}

/**
 * Reset DELETE state
 * @function resetDelete
 */
export function resetDelete() {
  return {
    type: RESET_DELETE,
  };
}

/* Get vocabulary Ore from redturtle.prenotazioni */
export function getVocOre() {
  const path =
    '@vocabularies/redturtle.prenotazioni.VocOreInizio?b_size=-1&b_start=0';

  return {
    type: GET_VOC_ORE,
    request: {
      op: 'get',
      path: path,
    },
  };
}

export function getVocBookingTypes(folderPath) {
  const path = `${expandToBackendURL(
    folderPath,
  )}/@vocabularies/design.plone.ioprenoto.booking_types`;

  return {
    type: GET_VOC_BOOKING_TYPES,
    request: {
      op: 'get',
      path: path,
    },
  };
}

/* Change slot */
export function moveBooking(folderPath, bookingId, bookingDate, gate) {
  const path = `${expandToBackendURL(folderPath)}/@booking-move`;

  return {
    type: MOVE_BOOKING,
    request: {
      op: 'post',
      path: path,
      data: {
        booking_id: bookingId,
        booking_date: bookingDate,
        gate: gate,
      },
    },
  };
}

/**
 * Reset move booking state
 * @function resetMoveBooking
 */
export function resetMoveBooking() {
  return {
    type: RESET_MOVE_BOOKING,
  };
}

/* Post vacation to block resource */
export function blockResource(folderPath, title, gate, startDate, endDate) {
  const path = `${expandToBackendURL(folderPath)}/@vacation`;

  return {
    type: ADD_VACATION,
    request: {
      op: 'post',
      path: path,
      data: {
        start: startDate,
        end: endDate,
        gate: gate,
        title: title,
      },
    },
  };
}

export function bookingReminder(folderPath, booking) {
  const path = `${expandToBackendURL(folderPath)}/@booking-notify/${
    booking.booking_id ?? booking.UID
  }`;

  return {
    type: BOOKING_REMINDER,
    request: {
      op: 'get',
      path: path,
    },
  };
}

export function resetBookingReminder() {
  return { type: BOOKING_RESET_REMINDER };
}

/**
 * Reset Add Vacation state
 * @function resetAddVacation
 */
export function resetAddVacation() {
  return {
    type: RESET_ADD_VACATION,
  };
}

/* Update booking */
export function updateBooking(booking) {
  const path = `${expandToBackendURL(
    booking['@id'], //?? '/ucman/2024/04/1/ddd',
  )}`;

  return {
    type: UPDATE_BOOKING,
    request: {
      op: 'patch',
      path: path,
      data: nestContent(booking),
    },
  };
}

/**
 * Reset booking update state
 * @function resetUpdateBooking
 */
export function resetUpdateBooking() {
  return {
    type: RESET_UPDATE_BOOKING,
  };
}
